import { HttpService } from '@/common/services/http.service';

const PageService = {
  PAGE_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  getPages() {
    return HttpService.httpGet(`${this.PAGE_API_HOST}/api/pages`);
  }
};

export default PageService;
